import request from '../axios'
import requestSec from '../axiosSec'

// 系统通知
// 查看全部站内信(列表)
export const sysnoticestationletterList = params => request({
	url: 'sysnotice/sysnoticestationletter/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		title: params.title ? encodeURIComponent(params.title) : ''
	}
})

// 获取消息类型
export const sysnoticestationlettertypeListAll = params => request({
	url: 'sysnotice/sysnoticestationlettertype/listAll',
	method: 'get',
	params: params
})

// 获取总条数/未读条数
export const sysnoticestationletterUserStationLetterNum = params => request({
	url: 'sysnotice/sysnoticestationletter/userStationLetterNum',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		title: params && params.title ? encodeURIComponent(params.title) : ''
	}
})

// 获取当前登录人所在组织信息
export const syscompanyorganizationCurrentOrg = params => request({
	url: 'sys/syscompanyorganization/currentOrg',
	method: 'get',
})

// 阅读站内信
export const sysnoticestationletterReadLetter = data => request({
	url: 'sysnotice/sysnoticestationletter/readLetter',
	method: 'post',
	data: data,
})

// 删除站内信
export const sysnoticestationletterstatusDelete = data => request({
	url: 'sysnotice/sysnoticestationletterstatus/delete',
	method: 'post',
	data: data,
})

// 发布站内信
export const sysnoticestationletterPush = data => request({
	url: 'sysnotice/sysnoticestationletter/push',
	method: 'post',
	data: data,
})

// 查看全部公告(列表)
export const sysnoticenoticeList = params => request({
	url: 'sysnotice/sysnoticenotice/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		title: params.title ? encodeURIComponent(params.title) : ''
	}
})

// 发布公告
export const sysnoticenoticePush = data => request({
	url: 'sysnotice/sysnoticenotice/push',
	method: 'post',
	data: data,
})

// 组织标签-下拉框
export const syscompanyorganizationCompanyOrganizationList = params => request({
	url: 'sys/syscompanyorganization/companyOrganizationList',
	method: 'get',
	params: params
})

// 公告置顶/取消置顶
export const sysnoticenoticeNoticeTopOr = data => request({
	url: 'sysnotice/sysnoticenotice/noticeTopOr',
	method: 'post',
	data: data,
})

// 获取1站内信/2公告模板数据
export const sysnoticetemplateListByType = params => request({
	url: 'sysnotice/sysnoticetemplate/listByType/' + params.type,
	method: 'get',
})

// 获取翻页ID
export const sysnoticestationletterPageInfo = params => request({
	url: 'sysnotice/sysnoticestationletter/pageInfo',
	method: 'get',
	params: params
})

// 站内信详情
export const sysnoticestationletterInfo = data => request({
	url: 'sysnotice/sysnoticestationletter/info',
	method: 'post',
	data: data,
})

// 公告详情
export const sysnoticenoticeInfo = params => request({
	url: 'sysnotice/sysnoticenotice/info/' + params.id,
	method: 'get',
})

// 编辑公告
export const sysnoticenoticeUpdate = data => request({
	url: 'sysnotice/sysnoticenotice/update',
	method: 'post',
	data: data,
})

// 删除公告(删除公告模板 传mainId)
export const sysnoticenoticeDelete = data => request({
	url: 'sysnotice/sysnoticenotice/delete',
	method: 'post',
	data: data,
})

// 获取接收人树形结构
export const sysdepartmentListByOrganization = params => request({
	url: 'sys/sysdepartment/listByOrganization',
	method: 'get',
	params: params
})

// 获取渠道信息
export const sysnoticeannounceChannels = params => request({
	url: 'sysnotice/sysnoticeannounce/channels',
	method: 'get',
	params: params
})

// 查看全部通告
export const sysnoticeannounceList = params => request({
	url: 'sysnotice/sysnoticeannounce/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		title: params.title ? encodeURIComponent(params.title) : ''
	}
})

// 站内消息--全部已读
export const sysnoticestationletterstatusReadAll = params => request({
	url: 'sysnotice/sysnoticestationletterstatus/readAll',
	method: 'get',
	params: params
})

// 发布通告
export const sysnoticeannouncePush = data => request({
	url: 'sysnotice/sysnoticeannounce/push',
	method: 'post',
	data: data,
})

// 获取通告详情
export const sysnoticeannounceInfo = params => request({
	url: 'sysnotice/sysnoticeannounce/info/' + params.id,
	method: 'get',
})

// 编辑通告
export const sysnoticeannounceUpdate = data => request({
	url: 'sysnotice/sysnoticeannounce/update',
	method: 'post',
	data: data,
})

// 删除通告(删除通告模板 传mainId)
export const sysnoticeannounceDelete = data => request({
	url: 'sysnotice/sysnoticeannounce/delete',
	method: 'post',
	data: data,
})

// 隐藏通告
export const sysnoticeannounceHideShow = data => request({
	url: 'sysnotice/sysnoticeannounce/hideShow',
	method: 'post',
	data: data,
})

// 查看全部平台工单
export const sysnoticeservicestationList = params => request({
	url: 'sysnotice/sysnoticeservicestation/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 查看工单详情
export const sysnoticeservicestationInfo = data => request({
	url: 'sysnotice/sysnoticeservicestation/info',
	method: 'post',
	data: data,
})

// 服务站--顶部各状态个数统计
export const sysnoticeservicestationTopNuminfo = params => request({
	url: 'sysnotice/sysnoticeservicestation/topNuminfo',
	method: 'get',
	params: params
})

// 结单
export const sysnoticeservicestationFinish = params => request({
	url: 'sysnotice/sysnoticeservicestation/finish/' + params.id,
	method: 'get',
})

// 回复工单
export const sysnoticeservicestationChat = data => request({
	url: 'sysnotice/sysnoticeservicestation/chat',
	method: 'post',
	data: data,
})

// 新增站内信类型
export const sysnoticestationlettertypeSave = data => request({
	url: 'sysnotice/sysnoticestationlettertype/save',
	method: 'post',
	data: data,
})

// 修改站内信类型
export const sysnoticestationlettertypeUpdate = data => request({
	url: 'sysnotice/sysnoticestationlettertype/update',
	method: 'post',
	data: data,
})

// 修改站内信类型颜色
export const sysnoticestationlettertypeUpdateColour = data => request({
	url: 'sysnotice/sysnoticestationlettertype/updateColour',
	method: 'post',
	data: data,
})

// 获取全部站内信、通告、公告模板数据
export const sysnoticeconfigAllData = params => request({
	url: 'sysnotice/sysnoticeconfig/allData',
	method: 'get',
	params: params
})

// 新增站内信模版
export const sysnoticestationletterSaveTemplate = data => request({
	url: 'sysnotice/sysnoticestationletter/save/template',
	method: 'post',
	data: data,
})

// 编辑站内信模版
export const sysnoticestationletterUpdateTemplate = data => request({
	url: 'sysnotice/sysnoticestationletter/update/template',
	method: 'post',
	data: data,
})

// 删除站内信模板
export const sysnoticestationletterDelete = data => request({
	url: 'sysnotice/sysnoticestationletter/delete',
	method: 'post',
	data: data,
})

// 新增公告模板
export const sysnoticenoticeSaveTemplate = data => request({
	url: 'sysnotice/sysnoticenotice/save/template',
	method: 'post',
	data: data,
})

// 编辑公告模版
export const sysnoticenoticeUpdateTemplate = data => request({
	url: 'sysnotice/sysnoticenotice/update/template',
	method: 'post',
	data: data,
})

// 新增通告模板
export const sysnoticeannounceSaveTemplate = data => request({
	url: 'sysnotice/sysnoticeannounce/save/template',
	method: 'post',
	data: data,
})

// 编辑通告模版
export const sysnoticeannounceUpdateTemplate = data => request({
	url: 'sysnotice/sysnoticeannounce/update/template',
	method: 'post',
	data: data,
})

// 站内信（模板）/公告（模板）/通告（模板）详情
export const sysnoticetemplateInfo = params => request({
	url: 'sysnotice/sysnoticetemplate/info/' + params.id,
	method: 'get'
})

// 获取配置基本数据
export const sysnoticeconfigInfo = params => request({
	url: 'sysnotice/sysnoticeconfig/info',
	method: 'get',
	params: params
})

// 修改通知配置
export const sysnoticeconfigUpdate = data => request({
	url: 'sysnotice/sysnoticeconfig/update',
	method: 'post',
	data: data,
})

// 通知详情获取服务站名称及头像
export const sysnoticeconfighomeServiceStationInfo = params => request({
	url: 'sysnotice/sysnoticeconfighome/serviceStationInfo',
	method: 'get',
	params: params
})

// 获取非常规站内信详情信息
export const sysnoticestationletterInfoOther = data => request({
	url: 'sysnotice/sysnoticestationletter/info/other',
	method: 'post',
	data: data,
})

// 获取菜单筛选项
export const sysnoticepublicityGetMenuList = params => request({
	url: 'sysnotice/sysnoticepublicity/getMenuList',
	method: 'get',
	params: params
})

// 获取公示列表
export const sysnoticepublicityList = params => request({
	url: 'sysnotice/sysnoticepublicity/list',
	method: 'get',
	params: params
})

// 主页公告清空接口
export const sysnoticepublicityEmpty = data => request({
	url: 'sysnotice/sysnoticepublicity/empty',
	method: 'post',
	data: data,
})

// 主页公告--编辑
export const sysnoticepublicityUpdate = data => request({
	url: 'sysnotice/sysnoticepublicity/update',
	method: 'post',
	data: data,
})

// 获取公示内容（根据路由路径）
export const sysnoticepublicityGetPublicityByUrl = params => request({
	url: 'sysnotice/sysnoticepublicity/getPublicityByUrl',
	method: 'get',
	params: params
})

// #标记查询
export const sysnoticepublicityFindMenu = params => request({
	url: 'sysnotice/sysnoticepublicity/findMenu',
	method: 'get',
	params: params
})

// 关闭公示
export const sysnoticepublicityswitchSave = data => request({
	url: 'sysnotice/sysnoticepublicityswitch/save',
	method: 'post',
	data: data,
})

// 工单加急/取消加急
export const sysnoticeservicestationUrgent = params => request({
	url: 'sysnotice/sysnoticeservicestation/urgent/' + params.id,
	method: 'get'
})

// 是否展示平台消息菜单项（是否是公版 公版时不显示通知配置--平台消息部分功能）
export const sysnoticeconfigPlatformShow = params => request({
	url: 'sysnotice/sysnoticeconfig/platformShow',
	method: 'get',
	params: params
})

// 根据档案编号，判断档案是否存在(材料/审批)
export const archiverecordArchiveExist = data => request({
	url: 'archive/archiverecord/archiveExist',
	method: 'post',
	data: data,
})

// 获取标注地址（级联数据）
export const sysfeedbackmarkQueryList = params => request({
	url: 'sys/sysfeedbackmark/queryList',
	method: 'get',
	params: params
})

// 根据路由获取标注地址 id/文本
export const sysfeedbackmarkQueryFeedByParam = params => request({
	url: 'sys/sysfeedbackmark/queryFeedByParam',
	method: 'get',
	params: params
})

// 新增问题反馈
export const sysfeedbackrecordSubmitFeedback = data => request({
	url: 'sys/sysfeedbackrecord/submitFeedback',
	method: 'post',
	data: data,
})

// 我的/收集反馈列表
export const sysfeedbackrecordList = params => request({
	url: 'sys/sysfeedbackrecord/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 收集反馈--顶部数据展示
export const sysfeedbackrecordTopData = params => request({
	url: 'sys/sysfeedbackrecord/topData',
	method: 'get',
	params: params
})

// 收集反馈--删除反馈
export const sysfeedbackrecordDelete = data => request({
	url: 'sys/sysfeedbackrecord/delete',
	method: 'post',
	data: data,
})

// 根据记录ID获取反馈详情
export const sysfeedbackrecordInfo = params => request({
	url: 'sys/sysfeedbackrecord/info/' + params.id,
	method: 'get'
})

// 收集反馈--批量处理反馈
export const sysfeedbackrecordDeal = data => request({
	url: 'sys/sysfeedbackrecord/deal',
	method: 'post',
	data: data,
})

// 通知配置--收集反馈--重新处理修改
export const sysfeedbackconfigToggleAllDealDefault = data => request({
	url: 'sys/sysfeedbackconfig/toggleAllDealDefault',
	method: 'post',
	data: data,
})

// 收集反馈状态列表
export const sysfeedbackconfigList = params => request({
	url: 'sys/sysfeedbackconfig/list',
	method: 'get',
	params: params
})

// 收集反馈清空接口
export const sysfeedbackconfigClear = params => request({
	url: 'sys/sysfeedbackconfig/clear/' + params.id,
	method: 'get'
})

// 收集反馈编辑接口
export const sysfeedbackconfigUpdate = data => request({
	url: 'sys/sysfeedbackconfig/update',
	method: 'post',
	data: data,
})

// 获取站内信基本信息（带二维码）
export const sysnoticenoticeInfoShow = params => request({
	url: 'sysnotice/sysnoticenotice/infoShow',
	method: 'get',
	params: params
})

// 获取主题配色
export const sysnoticeconfigGetColourListByMode = params => request({
	url: 'sysnotice/sysnoticeconfig/getColourListByMode',
	method: 'get',
	params: params
})
